var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"dir":_vm.dir}},[(_vm.load)?_c('div',[_c('Loading')],1):_vm._e(),_c('Nav',{on:{"dir":function($event){_vm.dir=$event}}}),_c('Header'),_c('Egypt'),_c('World'),_c('Symptoms'),_c('Table'),_c('Rules')],1)}
var staticRenderFns = []

export { render, staticRenderFns }